export default __webpack_public_path__ + "static/media/04-technology_thumb.96a32416.png";